import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'awair-loading-icon',
  templateUrl: './loading-icon.component.html',
  styleUrls: ['./loading-icon.component.scss']
})

export class LoadingIconComponent implements OnInit {

  @HostBinding('class.--black') hostBlack: boolean = false;
  @HostBinding('class.--small') hostSmall: boolean = true;
  @HostBinding('class.--large') hostLarge: boolean = false;

  @Input()
  set isBlack(value: boolean) {
    if (value != null) {
      this.hostBlack = value;
    }
  }

  @Input()
  set size(value: LoadingIconSize) {
    if (value != null) {
      [this.hostSmall, this.hostLarge] = (value === LoadingIconSize.Small) ? [true, false] : [false, true];
    }
  }

  constructor() {
  }

  ngOnInit() {
  }
}

export enum LoadingIconSize {
  Small = 'small',
  Large = 'large'
}
